export class Unitreqq{
    extRefNo?:string;
    plantName?:string;
    constructor(extRefNo?:string,
        plantName?:string){
            this.extRefNo = extRefNo
            this.plantName=plantName  
        }
}